import React from 'react'
import {
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/components/ui/dropdown-menu'

type DesktopSubmenuProps = {
  label: string
  sideOffset?: number
  alignOffset?: number
  children: React.ReactNode
}

/** One top-level desktop menu (File, Edit, …): a portaled submenu of the hamburger dropdown. */
export const DesktopSubmenu: React.FC<DesktopSubmenuProps> = ({
  label,
  sideOffset = 2,
  alignOffset = 0,
  children,
}) => {
  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{label}</DropdownMenuSubTrigger>
      <DropdownMenuPortal>
        <DropdownMenuSubContent
          align="start"
          sideOffset={sideOffset}
          alignOffset={alignOffset}
          className="w-[var(--menubar-menu-width)] max-w-[90vw]"
          data-text-edit-keepalive=""
        >
          {children}
        </DropdownMenuSubContent>
      </DropdownMenuPortal>
    </DropdownMenuSub>
  )
}
